







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { isBackgroundDeletable } from '@/common/helpers/background';

@Component
export default class BackgroundGallery extends Vue {
  @Prop({ default: () => [] }) readonly backgrounds!: any[];
  @Prop({ default: null }) readonly currentId!: number | null;
  @Prop({ default: true }) readonly allowDelete!: boolean;

  private canDelete(background): boolean {
    return isBackgroundDeletable(background, this.currentId, this.allowDelete);
  }
}
